


































import { Component, Vue } from "vue-property-decorator";
import { IAppList } from "@/interfaces";
import { RimRepairLayoutComponent } from "@/components/common";

@Component({
  components: {
    RimRepairLayoutComponent
  }
})
export default class OfficeComponent extends Vue {
  public items: IAppList[] = [
    {
      name: "Customers",
      icon: "",
      route: "office/customers"
    },
    {
      name: "Work Orders",
      icon: "",
      route: "office/work-orders"
    }
  ];

  goTo(path: string): void {
    if (this.$route.path !== path) this.$router.push(path);
  }
}


